import { render } from "./ProductOverview.vue?vue&type=template&id=5dcae019"
import script from "./ProductOverview.vue?vue&type=script&lang=js"
export * from "./ProductOverview.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__